module.exports = __webpack_public_path__ + "static/DraftKings_logo.3ca20c6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/team-logos/DraftKings_logo.png
// module id = 519
// module chunks = 35783957827783